module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


/*****************
 ** WEBPACK FOOTER
 ** external "react"
 ** module id = 1
 ** module chunks = 0
 **/